import { bootstrapApplication } from '@angular/platform-browser';
import '@angular/compiler';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { registerLicense } from '@syncfusion/ej2-base';
registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWH9ceHVVRGddWUZzWEFWYE4='
);
bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
